module.exports = __webpack_public_path__ + "img/thaigrouptextlogo.4af79d27.png";